import BaseConfig from "./BaseConfig";

export default class ContactEmail extends BaseConfig {
  label() {
    return this.customer?.supportEmail || this.toAddressMap[this.commodityType];
  }
}
